const E164_PATTERN = /^\+[1-9]\d{7,14}$/;
const stripPhoneFormatting = (phone) => phone.replace(/[\s\-().]/g, '');
/**
 * Normalizes a phone number to E.164 format.
 *
 * Handles common input formats:
 * - "0821234567" -> "+27821234567" with the default ZA country code
 * - "27821234567" -> "+27821234567"
 * - "+27821234567" -> "+27821234567"
 * - "082 123 4567" -> "+27821234567"
 * - "+1234567890" -> "+1234567890"
 * - "07123456789" -> "+447123456789" with defaultCountryCode="44"
 */
export function normalizePhone(phone, defaultCountryCode = '27') {
    if (!phone) {
        return null;
    }
    let cleaned = stripPhoneFormatting(phone);
    if (cleaned.startsWith('+')) {
        return E164_PATTERN.test(cleaned) ? cleaned : null;
    }
    if (cleaned.startsWith('00')) {
        const withoutPrefix = cleaned.slice(2);
        return /^[1-9]\d{7,14}$/.test(withoutPrefix) ? `+${withoutPrefix}` : null;
    }
    if (cleaned.startsWith('0')) {
        cleaned = `+${defaultCountryCode}${cleaned.slice(1)}`;
        return E164_PATTERN.test(cleaned) ? cleaned : null;
    }
    if (/^\d{10,15}$/.test(cleaned)) {
        return `+${cleaned}`;
    }
    return null;
}
export function isValidPhoneFormat(phone) {
    return normalizePhone(phone) !== null;
}
export function formatPhoneDisplay(phone) {
    if (!phone) {
        return '';
    }
    if (!E164_PATTERN.test(phone)) {
        return phone;
    }
    if (phone.startsWith('+27')) {
        const number = phone.slice(3);
        if (number.length === 9) {
            return `+27 ${number.slice(0, 2)} ${number.slice(2, 5)} ${number.slice(5)}`;
        }
    }
    if (phone.startsWith('+1') && phone.length === 12) {
        const number = phone.slice(2);
        return `+1 ${number.slice(0, 3)} ${number.slice(3, 6)} ${number.slice(6)}`;
    }
    const match = phone.match(/^\+(\d{1,3})(\d{3})(\d+)$/);
    return `+${match[1]} ${match[2]} ${match[3]}`;
}
export function phonesEqual(phone1, phone2) {
    const normalized1 = normalizePhone(phone1);
    const normalized2 = normalizePhone(phone2);
    return Boolean(normalized1 && normalized2 && normalized1 === normalized2);
}
export function extractCountryCode(phone) {
    if (!phone || !phone.startsWith('+')) {
        return null;
    }
    if (phone.startsWith('+27')) {
        return '27';
    }
    if (phone.startsWith('+1')) {
        return '1';
    }
    if (phone.startsWith('+44')) {
        return '44';
    }
    const match = phone.match(/^\+(\d{1,3})/);
    return match ? match[1] : null;
}
export function isSouthAfricanNumber(phone) {
    return normalizePhone(phone)?.startsWith('+27') ?? false;
}
export function isSouthAfricanMobile(phone) {
    const normalized = normalizePhone(phone);
    if (!normalized?.startsWith('+27')) {
        return false;
    }
    const digit = normalized.charAt(3);
    return digit === '6' || digit === '7' || digit === '8';
}
//# sourceMappingURL=index.js.map